/**
 * Order Tracking - Standalone page wrapping OrderTrackingReport
 * Accessible from Replenishment sidebar sub-menu
 */
import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { LocalShipping as TrackingIcon } from '@mui/icons-material';
import OrderTrackingReport from '../Reports/OrderTrackingReport';

const OrderTracking: React.FC = () => {
  return (
    <Box>
      <Paper sx={{ p: 3, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <TrackingIcon color="primary" />
          <Typography variant="h5">Order Tracking</Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Track replenishment orders by date, store, and delivery status. Monitor order progress from pending to delivered.
        </Typography>
      </Paper>
      <OrderTrackingReport />
    </Box>
  );
};

export default OrderTracking;
